import React from 'react'
import './ProjectCard.css'
import kanbanGif from '../../imgSource/projects/kanban.gif'
import jobTrackerGif from '../../imgSource/projects/job-tracker.gif'


export default function ProjectCard() {


  return (
    <div>

      <div className='projectCard'>
        <div className='projectLinks'>
          <a href='https://deles-jobtracker.netlify.app/'>
            <img className='projectIMG' src={jobTrackerGif} alt="Dele's Job Tracker gif" />
          </a>
          <a href='https://github.com/DeleAkinfenwa/Job-Tracker' className='projLink'>View the code here</a>
        </div>
        <div className='projectInfo'>
          <div className='projectName'>
            Dele's Job Tracker
          </div>
          <p className='projectDescription'>
            A full stack web app for keeping track of job applications, from "I'd like to work there" to the final offer. Every application sits in one table with a color-coded bar showing how many are at each stage (wishlist, applied, interviewing, offer, rejected or withdrawn), and you can search, sort, filter by stage and move an application to its next stage in one click. It also tracks your totals, interviews, offers and response rate.
          </p>
          <p className='projectDescription'>
            The frontend is built with React and talks to a REST API built with Python, Django and Django REST Framework, backed by a PostgreSQL database. Logins use JSON Web Tokens, each user only ever sees their own data, and a shared demo account resets itself so visitors can try it without signing up. It has 44 automated tests that run on every change with GitHub Actions.
          </p>
        </div>
      </div>

      <div className='projectCard'>
        <div className='projectLinks'>
          <a href='https://deles-kanban.netlify.app/'>
            <img className='projectIMG' src={kanbanGif} alt="Dele's Kanban Board gif" />
          </a>
          <a href='https://github.com/DeleAkinfenwa/Kanban' className='projLink'>View the code here</a>
        </div>
        <div className='projectInfo'>
          <div className='projectName'>
            Dele's Kanban Board
          </div>
          <p className='projectDescription'>
            A Kanban board for tracking work from idea to finished, built with React and Vite. Cards move through four columns (To Do, In Progress, Review, Done) by drag and drop or with arrow buttons, and each card has a priority, a color-coded category and an optional deadline with a live countdown. Everything is saved in the browser with localStorage, so no backend is needed.
          </p>
          <p className='projectDescription'>
            Anyone can move cards, while adding, editing and deleting is reserved for the Admin role, so visitors can try out permissions without signing up. Every card keeps a history of who created, edited or moved it, and the board also has search, deadline alerts, editable categories and a light/dark sky theme.
          </p>
        </div>
      </div>

      <div className='projectCard'>
        <div className='projectLinks'>
          <a href='https://socksquared.netlify.app/'>
            <img className='projectIMG' src='https://imgur.com/Ei8JX3T.gif' alt='Sock Squared gif' />
          </a>
          <a href='https://github.com/kiayaand20/sock2-app' className='projLink'>View the code here</a>
        </div>
        <div className='projectInfo'>
          <div className='projectName'>
            Sock²
          </div>
          <p className='projectDescription'>
            Sock² is an online shopping app that features creative design socks. This is a full stack project that uses React as the frontend and Python for the backend. The API database was created using SQL and is managed through MongoDB and Heroku. Users will be able to create an account, browse through all sock inventory, view specific sock details. Similarly, the app has full CRUD functionality for authorized users. </p>
          <p className='projectDescription'>
            I worked as a full stack developer on this project designing and creating the sign up/in screen, navigation, and item cards for the front end. On the backend I was involved in building the database and authorization.
          </p>
        </div>
      </div>



      <div className='projectCard'>
        <div className='projectLinks'>
          <a href='https://pkmnteambuilder.netlify.app/'>
            <img className='projectIMG' src='https://imgur.com/7jb0zMP.gif' alt='PKMN Team Builder gif' />
          </a>

          <a href='https://github.com/DeleAkinfenwa/pkmnTeamBuilder' className='projLink'>View the code here</a>
        </div>
        <div className='projectInfo'>
          <div className='projectName'>
            PKMN Team Builder
          </div>
          <p className='projectDescription'>
            The main goal of this REACT app is to get the user to create a team of pokemon, upload it to an API and be able to see other peoples uploaded teams. It features a form to get data from the user and a number of pages to navigate. The user will input their team and when the form is submitted it will grab that data from the official pokemon api and store it in the airtable API for that user.
          </p>
        </div>
      </div>

      <div className='projectCard'>
        <div className='projectLinks'>
          <a href='https://deleakinfenwa.github.io/Hunter-Notes/'>
            <img className='projectIMG' src='https://imgur.com/g1iwygU.gif' alt='Hunter Notes gif' />
          </a>

          <a href='https://github.com/DeleAkinfenwa/Hunter-Notes' className='projLink'>View the code here</a>
        </div>

        <div className='projectInfo'>
          <div className='projectName'>
            Hunter Notes
          </div>
          <p className='projectDescription'>
            This app created using HTML, JavaScript, and CSS. I used axios to pull data from an API and displayed that data based on the selection made by the user.
            <br />
            <br />
            Created as a companion app to the popular game Monster Hunter: World, this app allows you select a monster and have quick access to all the combat data you would need to take it down.
          </p>
        </div>
      </div>

    </div>
  )
}
